<template>
  <section class="captiontextsstyle">
    <!-- 表单 -->
    <el-form
      label-width="80px"
      :model="datas"
      size="small"
      :rules="rules"
      style="margin-top: 20px"
    >
      <!-- 标题内容 -->
      <el-form-item label="文本标题：">
        <div class="weiz">
          <div class="ml35">
            <el-input
              v-model="datas.name"
              placeholder="请输入标题"
              show-word-limit
            />
          </div>
        </div>
      </el-form-item>
      <!-- 标题大小 -->
      <el-form-item
        label="字号："
        prop="wordSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.wordSize" placeholder="请选择字号">
              <el-option
                v-for="item in wordSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="字体："
        prop="fontWeight"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.fontFamily" placeholder="请选择字体">
              <el-option
                v-for="item in fontFamilyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 标题颜色 -->
      <el-form-item label="颜色：">
        <div class="weiz">
          <div class="ml35">
            <!-- 颜色选择器 -->
            <el-color-picker
              v-model="datas.wordColor"
              show-alpha
              class="picke"
              :predefine="predefineColors"
            >
            </el-color-picker>
          </div>
        </div>
      </el-form-item>
      <!-- 描述内容 -->
      <el-form-item label="文本内容：">
        <div class="weiz">
          <div class="ml35">
            <el-input
              resize="none"
              type="textarea"
              v-model="datas.description"
              placeholder="一键开启高效通行"
              maxlength="30"
              show-word-limit
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item class="lef" label="背景：">
        <div class="weiz">
          <div class="ml35">
              <!--背景颜色子组件 -->
            <LinkInput :datas="datas" field="backColor" defaultColor="defaultBackColor" type="color" />
          </div>
        </div>
      </el-form-item>
      <el-form-item class="lef" label="跳转链接：">
        <div class="weiz">
          <div class="ml35">
            <div style="">
              <LinkSelectInput :type="1" :datas="datas" />
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import {
  wordSizeOptions,
  fontFamilyOptions,
  predefineColors,
} from "@/utils/defaultData.js";
export default {
  name: "captiontextsstyle",
  props: {
    datas: Object,
  },
  data() {
    let checkAge = (rule, value, callback) => {
      if (value.length === 0) callback(new Error("请输入有效数字"));
      if (value > 99) callback(new Error("数字最大为99"));
    };
    let kon = (rule, value, callback) => {
      if (value.length === 0) callback(new Error("请输入有效数字"));
    };
    return {
      // ✅ 新增：字体类型下拉列表【核心】
      fontFamilyOptions: fontFamilyOptions,
      // 字号下拉列表
      wordSizeOptions: wordSizeOptions,
      // 标题粗细下拉列表
      options: [
        {
          value: "normal",
          label: "正常",
        },
        {
          value: "bold",
          label: "加粗",
        },
      ],
      rules: {
        wordSize: [{ required: true, validator: checkAge, trigger: "blur" }],
        descriptionSize: [
          { required: true, validator: checkAge, trigger: "blur" },
        ],
        wordWeight: [{ required: true, validator: kon, trigger: "blur" }],
        descriptionWeight: [
          { required: true, validator: kon, trigger: "blur" },
        ],
      },
      predefineColors: predefineColors,
    };
  },
  mounted() {
    console.log("描述文字设置------------11111-1111111111-1111111", this.datas);
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
// 覆盖element原有样式
::v-deep.el-form {
  .el-card {
    .el-card__body {
      padding: 10px 0;
      .el-form-item {
        .el-form-item__label {
          color: #9c9b9b !important;
          font-size: 13px !important;
        }
        .el-form-item__content {
          margin-left: 20px !important;
          margin-right: 20px !important;
        }
      }
    }
  }
}
.captiontextsstyle {
  width: 100%;
  // position: absolute;
  left: 0;
  top: 0;
  padding: 0 10px 20px;
  box-sizing: border-box;

  /* 标题 */
  h2 {
    padding: 24px 16px 24px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f4f6;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }

  /* 颜色选择器 */
  .picke {
    float: right;
  }

  /* 位置 */
  .weiz {
    display: flex;
    .weiz-content {
      margin-left: 35px;
      width: 100%;
    }
    .weiz-container {
      margin-left: 10px;
      width: 100%;
    }
    i {
      padding: 5px 14px;
      margin-left: 10px;
      border-radius: 0;
      border: 1px solid #ebedf0;
      font-size: 20px;
      font-weight: 500;
      cursor: pointer;

      &:last-child {
        font-size: 22px;
      }

      &.active {
        color: #155bd4;
        border: 1px solid #155bd4;
        background: #e0edff;
      }
    }
  }

  ::v-deep.wid .el-form-item__label {
    width: 94px !important;
  }
  ::v-deep.wid .el-form-item__content {
    float: right;
  }
}
</style>
